import React from 'react'
import { OrderStatusBadge } from '../StatusBadge'
import { Link } from 'react-router-dom'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { truncate } from '@ztechapps/common.utils'
import { OrderPaymentStatusBadge } from '../OrderPaymentStatusBadge'
import type { OrderPaymentStatusEnum } from '@ztechapps/common.contract'

export type OrderWidgetProps = {
  summary?: any
  code: string
  status: string
  truncateSize?: number
  linkTo?: string
  paymentStatus?: OrderPaymentStatusEnum
  customerPoNumber?: string
}

export const OrderWidget = ({
  summary,
  code,
  status,
  truncateSize = 50,
  linkTo,
  paymentStatus,
  customerPoNumber,
}: OrderWidgetProps) => {
  const codeComponent = <b>{code}</b>

  return (
    <div>
      <div>
        <HorizontalStack gap={2}>
          <OrderStatusBadge status={status} />
          <ShowIf condition={!!linkTo}>
            <Link to={linkTo}>{codeComponent}</Link>
          </ShowIf>
          <ShowIf condition={!linkTo}>{codeComponent}</ShowIf>

          {paymentStatus && <OrderPaymentStatusBadge paymentStatus={paymentStatus} />}
        </HorizontalStack>
        {!!summary && <small>{truncate(summary, truncateSize)}</small>}
      </div>
      <ShowIf condition={!!customerPoNumber}>
        <small>
          <b>Customer PO #:</b> {customerPoNumber}
        </small>
      </ShowIf>
    </div>
  )
}
